import { lazy } from 'react';

const Test = lazy(() => import('../pages/private/Test'));

const Dashboard = lazy(() => import('../pages/private/Dashboard'));
const Profile = lazy(() => import('../pages/private/Profile'));
const Orders = lazy(() => import('../pages/private/Orders'));
const OrderInfo = lazy(() => import('../pages/private/OrderInfo'));
const ShippingDetails = lazy(() => import('../pages/private/ShippingDetails'));
const Cart = lazy(() => import('../pages/private/Cart'));
const Wishlist = lazy(() => import('../pages/private/Wishlist'));
const Checkout = lazy(() => import('../pages/private/Checkout'));
const DescendantList = lazy(() => import('../pages/private/DescendantList'));

export const ProtectedRouteList = [
  { path: 'dashboard', element: <Dashboard /> },
  { path: 'test', element: <Test /> },
  { path: 'profile', element: <Profile /> },
  { path: 'orders', element: <Orders /> },
  { path: 'order-info', element: <OrderInfo /> },
  { path: 'shipping', element: <ShippingDetails /> },
  { path: 'cart', element: <Cart /> },
  { path: 'wishlist', element: <Wishlist /> },
  { path: 'checkout', element: <Checkout /> },
  { path: 'descendant-list', element: <DescendantList /> },
];
